const formatTrustee = (trustee) => {
  const name = trustee?.displayName
  const mail = trustee?.mail
  if (name && mail && name.toLowerCase() !== mail.toLowerCase()) {
    return `${name} (${mail})`
  }
  return name || mail || ''
}

export default formatTrustee
